export enum OrganizationUsersModalsEnum {
  DELETE_ORGANIZATION_USER = 'DELETE_ORGANIZATION_USER',
  SAVE_ORGANIZATION_USER = 'SAVE_ORGANIZATION_USER',
  SEND_REGISTRATION_LINK_TO_USER = 'SEND_REGISTRATION_LINK_TO_USER',
  SET_ORGANIZATION_USER_STATUS = 'SET_ORGANIZATION_USER_STATUS',
}
